import React from "react";

function FailedTranscations() {
  return (
    <svg
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <rect width="32" height="32" fill="#FFF1F0" rx="8"></rect>
      <path
        fill="#F5222D"
        stroke="#F5222D"
        strokeWidth="0.1"
        d="M23.59 21.535l.035.036.035-.036c.144-.145.246-.304.304-.478.058-.172.086-.358.086-.557v-9c0-.426-.152-.792-.455-1.095A1.494 1.494 0 0022.5 9.95H12.005l.085.085 1.5 1.5.014.015h8.846v1.4h-7.445l.085.085 3 3 .014.015h4.346v4.345l.015.015 1.125 1.125zM10.035 9.965l-.014-.015-1.229-1.228a.78.78 0 00-.563-.251.768.768 0 00-.556.244.808.808 0 00-.254.554.73.73 0 00.233.558s0 0 0 0l.662.667a1.488 1.488 0 00-.364 1v9.005c0 .426.152.792.455 1.095.303.304.67.456 1.095.456h10.354l2.298 2.298c.162.162.352.24.568.233a.818.818 0 00.565-.254.747.747 0 00.244-.553.784.784 0 00-.25-.567L11.745 11.675l-.086-.085-1.625-1.625zm.72 2.985H9.55v-1.213l1.205 1.213zm-1.205 7.5v-4.4h4.304l4.4 4.4H9.55z"
      ></path>
    </svg>
  );
}

export default FailedTranscations;